export default "__VITE_ASSET__e77b5573__"